<template>
    <el-container>
        <el-main>
            <div id="dialogs">
                <el-dialog :title="showDeatilsTitle" :visible.sync="showDeatils" :close-on-click-modal=false :before-close="handleDialogClose">
                    <el-form ref="logForm"  :model="formData" label-width="100px"  class="demo-ruleForm">
                        <el-form-item label="操作人" prop="optName">
                            <el-input v-model="formData.optName"  placeholder="操作人" :disabled="isUpdate"></el-input>
                        </el-form-item>
                         <el-form-item label="操作类型" prop="optType">
                            <el-input v-model="formData.optType"  placeholder="操作类型" :disabled="isUpdate"></el-input>
                        </el-form-item>
                         <el-form-item label="IP地址" prop="optIP">
                            <el-input v-model="formData.optIP"  placeholder="IP地址" :disabled="isUpdate"></el-input>
                        </el-form-item>
                         <el-form-item label="操作时间" prop="optTime">
                            <el-input v-model="formData.optTime"  placeholder="操作时间" :disabled="isUpdate"></el-input>
                        </el-form-item>
                        <el-form-item  label="操作描述" prop="optDescription">
                            <el-input type="textarea" :rows="6"  v-model="formData.optDescription"  :disabled="isUpdate"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="handleDialogClose">关 闭</el-button>
                    </div>
                </el-dialog>
            </div>
            <el-form :model="searchData" label-position="top" label-width="80px">
                <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label="操作人" prop="optName" class="cls-col">
                            <el-input v-model="searchData.optName" placeholder="操作人" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="操作类型" prop="optType" class="cls-col">
                            <el-input v-model="searchData.optType" placeholder="操作类型" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                     <el-col :span="4">
                        <el-form-item label="IP地址" prop="optIP" class="cls-col">
                            <el-input v-model="searchData.optIP" placeholder="IP地址" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                  <el-col :span="4">
                    <el-form-item label="操作时间开始" prop="optTime1" class="cls-col">
                      <!-- <el-input v-model="searchData.optTimeBegin" placeholder="操作时间开始" size="small"></el-input> -->
                      <el-date-picker
                          v-model="searchData.optTime1"
                          type="date"
                          size="small"
                          value-format="yyyy-MM-dd"
                          placeholder="选择日期">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="操作时间结束" prop="optTime2" class="cls-col">
                      <!-- <el-input v-model="searchData.optTimeEnd" placeholder="操作时间结束" size="small"></el-input> -->
                      <el-date-picker
                          v-model="searchData.optTime2"
                          type="date"
                          size="small"
                          value-format="yyyy-MM-dd"
                          placeholder="选择日期">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                
                <el-form-item>
                    <el-button type="primary" size="small" plain @click="search()">查询</el-button>
                </el-form-item>
            </el-form>           
            <el-table
                    :data="modelData"
                    border
                    highlight-current-row
                    v-loading="loading"
                    style="width: 100%"
                     @selection-change="handleSelectionChange"
            >
                <el-table-column
                        type="index"
                        label="序号"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="optName"
                        label="操作人"
                        align="center"
                >
                </el-table-column>
                <el-table-column
                        prop="optType"
                        label="操作类型"
                >
                </el-table-column>
                <el-table-column
                        prop="optIP"
                        label="IP地址"
                >
                </el-table-column>
                <el-table-column
                        prop="optTime"
                        label="操作时间"
                        :formatter="dateFormat"
                >
                </el-table-column>

                <el-table-column
                        fixed="right"
                        label="操作"
                        width="200"
                >
                    <template slot-scope="scope">
                        <el-button @click="showDetails(scope.$index, scope.row)"  size="small" type="text" showDeatilsTitle="日志详情">详情</el-button>
                   </template>
                </el-table-column>
            </el-table>
           <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    :current-page.sync="currentPage"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    style="margin-top: 10px; float: right; margin-right: 10px">
            </el-pagination>
        </el-main>
    </el-container>
</template>

<script>
    import https from '@/https.js'
    import {dateFormat} from '@/api/utils.js'
    const formData = {
        logId: "",
        optName: "",
        optType: "",
        optDescription: "",
        optTime: "",
        optIP: ""
    };
    export default {
        name: "log",
        components: {            
        },
        data() {           
            return {
                modelData:[],
                rules: {
                },              
                searchData: {
                    optName: null,
                    optType: null,
                    optIP: null,
                    optTimeBegin: null,
                    optTimeEnd: null,
                    page: 0,
                    size: 10
                },         
                pageSize:10,
                loading: false,
                total: 0,
                multipleSelection : [],
                _logId: "",
                showDeatilsTitle: "",
                showDeatils:false,
                checkedKeys: [],
                currentPage: 1,
                isUpdate: true,
                formData:""
            }
        },
        methods: {   
             handleDialogClose() {
                 let that = this;
                that.showDeatils = false;
            }, 
            handleSizeChange() {
            },
            handleCurrentChange(val) {
                this.search(val);
            },
            handleSelectionChange(val) {
                this.multipleSelection = [];
                for(let index in val) {
                    this.multipleSelection[index] =  val[index].logId;
                }
            },
            showDetails(index, row){
                row.optTime = dateFormat(row.optTime);
                this.formData = JSON.parse(JSON.stringify(row));
                this.showDeatilsTitle = "日志详情";
                this.showDeatils=true;  
            },          
            search(val) {
               this.searchData.size = this.pageSize;
                if(val) {
                    this.searchData.page = val;
                } else {
                    this.searchData.page = 1;
                    this.currentPage = 1;
                }
                if(this.searchData.optTime1){
                    this.searchData.optTimeBegin=this.searchData.optTime1+" 00:00:00";
                }
                else{
                    this.searchData.optTimeBegin=null;
                }
                if(this.searchData.optTime2){
                    this.searchData.optTimeEnd=this.searchData.optTime2+" 23:59:59";
                }
                else{
                    this.searchData.optTimeEnd=null;
                }

                let params = this.searchData;
                  https.fetchGet('/managerLog/searchLog',JSON.parse(JSON.stringify(params)),"json" ).then((data) => {
                    let code = data.data.code;
                    if(code == '200') {
                        this.modelData = data.data.data.list;
                        this.total = data.data.data.total;
                        this.loading = false;
                    }
                }).catch(err=>{
                        console.log(err)
                    }
                )
            },
            dateFormat(row, column, cellValue, index) {
                if(cellValue != null) {
                    return dateFormat(cellValue);
                } else {
                    return cellValue
                }
            }             
        },
        created: function () {
            this.search(1);
        }
    }
</script>

<style scoped>
.add-button {
    margin-bottom: 5px;
}
.but-cls {
    margin-bottom: 10px;
}
.cls-col {
    margin-right: 20px;
}
.el-input.is-disabled .el-input__inner,.el-input.is-disabled .el-textarea__inner{
    color:#000;
}
</style>